var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuredManaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 205,
    viewBox: "0 0 254 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_488_1251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.14 13.4159L209.259 15.8611C168.758 15.3599 146.94 11.4109 134.331 2.48999C121.118 11.8347 97.7944 15.7266 53.4609 15.906V124.02C53.4609 168.617 134.536 204.28 134.536 204.28C134.536 204.28 215.202 168.617 215.202 124.02V15.91L211.14 13.4159Z",
    fill: "url(#paint0_linear_488_1251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.258 0C117.045 9.34474 93.7212 13.2367 49.3877 13.416V121.53C49.3877 166.127 130.258 202.275 130.258 202.275C130.258 202.275 211.129 166.127 211.129 121.53V13.416C166.795 13.2367 143.471 9.34474 130.258 0ZM175.906 101.138C175.906 113.225 171.097 124.817 162.536 133.364C153.975 141.91 142.365 146.712 130.258 146.712C124.263 146.713 118.326 145.535 112.787 143.245C107.248 140.955 102.215 137.599 97.975 133.366C93.7354 129.134 90.3722 124.11 88.0777 118.58C85.7832 113.05 84.6022 107.123 84.6022 101.138C84.6022 89.0505 89.4115 77.4584 97.9722 68.9115C106.533 60.3647 118.143 55.5631 130.25 55.5631C137.497 55.5574 144.642 57.2768 151.09 60.5789C157.539 63.8809 163.106 68.6703 167.33 74.55L175.939 65.9552L184.021 74.0244L172.971 85.0563C174.917 90.1951 175.911 95.644 175.906 101.138Z",
    fill: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.905 101.138C175.905 113.225 171.096 124.817 162.535 133.364C153.975 141.91 142.364 146.712 130.258 146.712C124.262 146.713 118.326 145.535 112.786 143.245C107.247 140.955 102.214 137.599 97.9744 133.366C93.7347 129.134 90.3716 124.11 88.0771 118.58C85.7825 113.05 84.6016 107.123 84.6016 101.138C84.6016 89.0505 89.4109 77.4584 97.9715 68.9115C106.532 60.3647 118.143 55.5631 130.249 55.5631C137.497 55.5573 144.641 57.2768 151.09 60.5789C157.538 63.8809 163.105 68.6704 167.329 74.55L129.017 112.805L105.75 89.5758L97.6677 97.645L129.009 128.944L172.966 85.0563C174.913 90.1948 175.909 95.6437 175.905 101.138Z",
    fill: "url(#paint1_linear_488_1251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.024 74.0242L129.017 128.943L97.6758 97.6449C102.141 93.1864 109.374 93.1867 113.839 97.6456L129.021 112.805L167.333 74.55L175.942 65.9551L184.024 74.0242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.32 132.363L110.974 139.319C101.439 140.261 93.712 148.766 93.712 158.318L93.0059 225.619C95.5366 230.016 101.439 235.839 110.966 234.898L154.12 230.631C163.655 229.69 171.378 221.18 171.378 211.628V150.641C171.386 141.088 163.708 133.117 154.32 132.363Z",
    fill: "url(#paint2_linear_488_1251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.729 132.342L107.575 136.605C98.0395 137.551 90.3125 146.056 90.3125 155.608V216.596C90.3125 226.148 98.0395 233.125 107.575 232.184L150.729 227.921C160.26 226.98 167.987 218.47 167.987 208.918V147.93C167.983 138.378 160.256 131.401 150.729 132.342ZM100.211 149.023L134.091 145.673V153.049L100.211 156.399V149.023ZM117.155 219.546L100.211 221.221V213.849L117.155 212.174V219.546ZM158.088 215.504L148.149 216.486V209.109L158.088 208.127V215.504ZM158.088 191.019L100.211 196.724V189.352L158.088 183.647V191.019ZM158.088 181.413L100.211 187.119V179.743L158.088 174.037V181.413ZM158.088 171.812L100.211 177.517V170.165L158.088 164.46V171.812ZM158.088 162.21L100.211 167.916V160.544L158.088 154.838V162.21Z",
    fill: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.095 145.673V153.053L100.207 156.399V149.023L134.095 145.673Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.084 154.834V162.21L100.207 167.928V160.556L158.084 154.834Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.084 164.44V171.812L100.207 177.534V170.157L158.084 164.44Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.084 174.041V181.417L100.207 187.135V179.763L158.084 174.041Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.084 183.647V191.019L100.207 196.737V189.364L158.084 183.647Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.151 212.174V219.55L100.207 221.225V213.849L117.151 212.174Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.084 208.127V215.504L148.145 216.486V209.113L158.084 208.127Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.384 130.786L242.743 81.1644C241.779 73.2216 234.416 65.4417 226.297 63.7871L190.041 49.5234C183.102 50.0736 175.628 59.7118 176.571 67.675L182.739 118.38C183.702 126.323 191.07 134.103 199.185 135.758L235.922 143.248C244.077 144.898 252.543 134.274 253.384 130.786Z",
    fill: "url(#paint3_linear_488_1251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.285 57.2421L194.547 49.7516C186.429 48.097 180.628 53.1952 181.596 61.1381L187.759 111.843C188.727 119.786 196.09 127.566 204.209 129.221L240.946 136.711C249.065 138.366 254.862 133.267 253.894 125.325L247.731 74.6193C246.763 66.6765 239.403 58.9089 231.285 57.2421ZM189.445 58.1957L218.304 64.0764L219.051 70.2097L190.192 64.3291L189.445 58.1957ZM211.173 121.164L196.744 118.225L195.997 112.092L210.426 115.034L211.173 121.164ZM246.032 128.267L237.567 126.543L236.82 120.41L245.285 122.138L246.032 128.267ZM243.555 107.89L194.27 97.8446L193.523 91.7316L242.812 101.773L243.555 107.89ZM242.583 99.9067L193.298 89.8814L192.551 83.7684L241.84 93.81L242.583 99.9067ZM241.616 91.9231L192.327 81.8775L191.58 75.7645L240.869 85.8101L241.616 91.9231ZM240.644 83.9354L191.355 73.8939L190.613 67.7605L239.897 77.8062L240.644 83.9354Z",
    fill: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.304 64.0764L219.047 70.2098L190.188 64.3291L189.445 58.1957L218.304 64.0764Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.897 77.8265L240.64 83.9599L191.355 73.9142L190.608 67.7849L239.897 77.8265Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.869 85.8102L241.612 91.9436L192.327 81.8979L191.58 75.7686L240.869 85.8102Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.841 93.7978L242.584 99.9271L193.299 89.8855L192.552 83.7521L241.841 93.7978Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.807 101.781L243.554 107.911L194.265 97.8691L193.522 91.7357L242.807 101.781Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.427 115.034L211.174 121.164L196.744 118.225L195.997 112.092L210.427 115.034Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.285 122.138L246.028 128.271L237.566 126.543L236.819 120.414L245.285 122.138Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.616211 135.488L11.2577 85.8631C12.2251 77.9203 19.5889 70.1446 27.7037 68.49L63.9591 54.2263C70.8983 54.7724 78.3763 64.4147 77.4293 72.3738L71.2656 123.083C70.2982 131.026 62.9345 138.806 54.8156 140.46L18.0786 147.947C9.92294 149.609 1.45708 138.973 0.616211 135.488Z",
    fill: "url(#paint4_linear_488_1251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7203 61.945L59.4573 54.4545C67.5762 52.7999 73.3766 57.8941 72.4092 65.837L66.2455 116.546C65.2781 124.485 57.9144 132.269 49.7955 133.924L13.0584 141.41C4.93954 143.065 -0.856745 137.966 0.106582 130.023L6.27432 79.3182C7.23765 71.3754 14.6014 63.5996 22.7203 61.945ZM64.5556 62.8946L35.6966 68.7753L34.9537 74.9087L63.8127 69.028L64.5556 62.8946ZM42.8277 125.867L57.2572 122.924L58.0042 116.811L43.5747 119.75L42.8277 125.867ZM7.9724 132.97L16.4342 131.242L17.1811 125.129L8.71529 126.853L7.9724 132.97ZM10.446 112.593L59.7349 102.552L60.4778 96.4183L11.193 106.464L10.446 112.593ZM11.4175 104.61L60.7023 94.5681L61.4493 88.4347L12.1645 98.4804L11.4175 104.61ZM12.389 96.6261L61.6738 86.5844L62.4208 80.4714L13.1319 90.5131L12.389 96.6261ZM13.3605 88.6425L62.6453 78.5969L63.3923 72.4839L14.1034 82.5458L13.3605 88.6425Z",
    fill: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6962 68.7752L34.9492 74.9086L63.8082 69.0279L64.5552 62.8945L35.6962 68.7752Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1034 82.5295L13.3564 88.6588L62.6453 78.6171L63.3882 72.4838L14.1034 82.5295Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1318 90.5131L12.3848 96.6424L61.6736 86.6008L62.4206 80.4674L13.1318 90.5131Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1601 98.4967L11.4131 104.63L60.702 94.5844L61.449 88.451L12.1601 98.4967Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1892 106.48L10.4463 112.614L59.7311 102.568L60.4781 96.4346L11.1892 106.48Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5741 119.733L42.8271 125.867L57.2566 122.924L57.9996 116.795L43.5741 119.733Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71476 126.837L7.96777 132.97L16.4336 131.246L17.1806 125.113L8.71476 126.837Z",
    fill: "#AAD0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_488_1251",
    x1: 53.5023,
    y1: 103.401,
    x2: 215.202,
    y2: 103.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_488_1251",
    x1: 84.6249,
    y1: 101.145,
    x2: 175.905,
    y2: 101.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_488_1251",
    x1: 93.0259,
    y1: 183.689,
    x2: 171.378,
    y2: 183.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_488_1251",
    x1: 176.51,
    y1: 96.4794,
    x2: 253.384,
    y2: 96.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_488_1251",
    x1: 0.635855,
    y1: 101.181,
    x2: 77.5108,
    y2: 101.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DEFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_488_1251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 235,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuredManaged);
export default __webpack_public_path__ + "static/media/insured_managed.26ae8e9b4de2fad30019ffb2e1f4fa39.svg";
export { ForwardRef as ReactComponent };